import { Form, Input, Modal } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { FormInstance } from 'antd/lib'
import { Dispatch, FC, SetStateAction, useContext, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import { AuthContext } from 'src/components/Auth/AuthProvider'
import { CommunicationContext } from 'src/context/CommunicationContext'
import i18n from 'src/libs/i18n.lib'
import { submitFeedback } from 'src/utils/platform'
import styled from 'styled-components'
import FeedbackButtons from './FeedbackButtons'

interface FeedFwdModalProp {
  flow?: string
  currentFeedback: string
  setCurrentFeedback: (value: string) => void
  setFlow: Dispatch<SetStateAction<string>>
  form: FormInstance
}

interface FormValue {
  id: string
  feedbackTarget: string
  targetId: string
}

const StyledFormItemLabel = styled.span`
  width: 70px; /* Set a fixed width for the labels */
  text-align: left;
`

const FeedFwdModal: FC<FeedFwdModalProp> = ({
  form,
  setFlow,
  currentFeedback,
  setCurrentFeedback,
}) => {
  const { userInfo, auth } = useContext(AuthContext)
  const { t } = useTranslation()
  const { feedbackModal, setFeedbackModal, setReviewRef } =
    useContext(CommunicationContext)

  const handleFeedbackButtonsClick = async (values: FormValue) => {
    const { id, targetId, feedbackTarget } = values
    if (id !== 'anonymous' && id !== 'direct') return
    const senderId = userInfo?.stsUserId
    const targetType = feedbackTarget === 'person' ? 'user' : 'team'
    const stsOrganisationId = userInfo?.organization?.stsOrganisationId
    const feedback = currentFeedback

    if (id === 'anonymous') {
      await submitFeedback(
        auth?.token,
        senderId,
        targetId,
        targetType,
        feedback,
        true,
        i18n.language,
        stsOrganisationId,
      )
    } else {
      await submitFeedback(
        auth?.token,
        senderId,
        targetId,
        targetType,
        feedback,
        false,
        i18n.language,
        stsOrganisationId,
      )
    }
    setCurrentFeedback('')
  }

  return (
    <div>
      <Modal
        centered
        destroyOnClose
        open={feedbackModal}
        title={t('resources.feedbacks.action.sendFeedback', 'Sending Feedback')}
        width={isMobile ? '100%' : '60%'}
        footer={
          <FeedbackButtons
            disabled={!currentFeedback}
            form={form}
            handleFeedbackButtonsClick={handleFeedbackButtonsClick}
            setFlow={setFlow}
          />
        }
        onCancel={() => setFeedbackModal(false)}
      >
        <div ref={setReviewRef}>
          <Form form={form} name="control-hooks">
            <Form.Item
              name="targetName"
              label={
                <StyledFormItemLabel>{t('action.sendTo')}</StyledFormItemLabel>
              }
            >
              <Input disabled />
            </Form.Item>
            <Form.Item
              label={
                <StyledFormItemLabel>
                  {t('common.word.feedback')}
                </StyledFormItemLabel>
              }
            >
              <TextArea
                value={currentFeedback}
                autoSize={{
                  minRows: 5,
                  maxRows: 5,
                }}
                style={{
                  resize: 'none',
                }}
                onChange={(e) => setCurrentFeedback(e.target.value)}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

export default FeedFwdModal
